export const customerPortalPage = pathname => {
  return ['/bookings', '/account'].some(prefix => pathname.startsWith(prefix));
};
